export class Sip {
  constructor({
    sipId = 0,
    orderID = 0,
    connectionType = null,
    hardware = null,
    sipRows = [],
  } = {}) {
    this.sipId = sipId;
    this.orderID = orderID;
    this.connectionType = connectionType;
    this.hardware = hardware;
    this.sipRows = sipRows;
  }
}
export function createNewSip(data) {
  return Object.freeze(new Sip(data));
}
